import React from 'react';

import { ITableFields } from '../../../types/contentful';

import { StandardTable } from './StandardTable';
import { ShortFormTable } from './ShortFormTable';
import { BasicTable } from './BasicTable';

export enum tableStyles {
  basic = 'Basic',
  standard = 'Standard',
  shortForm = 'Short Form',
  longForm = 'Long Form'
}

export function Tables({ designType, ...table }: ITableFields) {
  switch (designType) {
    case tableStyles.shortForm:
      return <ShortFormTable {...table} />;

    case tableStyles.longForm:
      return <BasicTable basic={false} {...table} />;

    case tableStyles.standard:
      return <StandardTable {...table} />;

    case tableStyles.basic:
    default:
      return <BasicTable {...table} />;
  }
}
